import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useApiPut, useApiDelete } from '../../../../api/hooks';
import LabeledInput from '../controls/LabeledInput';
import PasswordRules, { isValidPassword } from '../controls/PasswordRules';

const USERS_URL = '/api/camps/admin/users';

// Карточка организатора: редактирование профиля + смена пароля + удаление.
export default function OrgCard({ org, onDeleted }) {
    const [name, setName] = useState(org.name || '');
    const [surname, setSurname] = useState(org.surname || '');
    const [password, setPassword] = useState('');

    // Пароль опционален (пусто = не менять); если задан — должен пройти правила.
    const passwordInvalid = password.length > 0 && !isValidPassword(password);

    const saveOrg = useApiPut({ successMessage: 'Сохранено', withPreloader: true });
    const deleteOrg = useApiDelete({
        successMessage: 'Удалено',
        withPreloader: true,
        onSuccess: () => onDeleted(org.userId)
    });

    const handleSave = () => {
        if (passwordInvalid) return;
        const data = { name, surname };
        if (password) data.password = password;
        saveOrg.mutate({ url: `${USERS_URL}/${org.userId}`, data });
    };

    const handleDelete = () => {
        deleteOrg.mutate({ url: `${USERS_URL}/${org.userId}` });
    };

    return (
        <div className="org-card">
            <LabeledInput label="Имя" value={name} onChange={(e) => setName(e.target.value)} />
            <LabeledInput label="Фамилия" value={surname} onChange={(e) => setSurname(e.target.value)} />
            <div className="org-login">
                <LabeledInput label="Login" value={org.username || ''} onChange={() => {}} disabled />
                <div>
                    <LabeledInput
                        label="Пароль"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Оставьте пустым"
                    />
                    <PasswordRules password={password} />
                </div>
            </div>
            <div className="org-acts">
                <button type="button" className="btn btn-danger" onClick={handleDelete} disabled={deleteOrg.isPending}>
                    Удалить
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSave} disabled={saveOrg.isPending || passwordInvalid}>
                    Сохранить
                </button>
            </div>
        </div>
    );
}

OrgCard.propTypes = {
    org: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        userId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        username: PropTypes.string,
        name: PropTypes.string,
        surname: PropTypes.string
    }).isRequired,
    onDeleted: PropTypes.func.isRequired
};
